

import { Component, Vue, Prop } from "vue-property-decorator"
import FolderService from "@/services/folder-service"

/**
 * @summary Component for folder rows in tables
 */
@Component({
	components: {
	}
})
export default class FolderTableHeader extends Vue {
    @Prop()
    folderService!: FolderService

    @Prop()
    item!: { isFolderType?: boolean, folderTitle?: string }
}

